

  <!--  <div class="section">-->
  <!--    <div class="container">-->
  <!--      <div class="section-top">-->
  <!--        <h3>Reset your password</h3>-->
  <!--      </div>-->
  <!--      <div class="form-area">-->
  <!--        <div class="form">-->
  <!--          <form>-->

  <!--            <div class="form-input">-->
  <!--              <input type="password" placeholder="Enter new password">-->
  <!--            </div>-->
  <!--            <div class="form-input">-->
  <!--              <input type="password" placeholder="Re-type your new password">-->
  <!--            </div>-->
  <!--            <div class="sub-btn">-->
  <!--              <ul>-->
  <!--                <li><button type="submit" routerLink="">Change Password</button></li>-->
  <!--              </ul>-->
  <!--            </div>-->
  <!--          </form>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->


  <div class="section">
    <div class="container">
      <div class="section-main">
        <div class="reset-password">
          <div class="reset-password-top">
            <h3>Reset your password?</h3>
            <!--            <span routerLink="/login"><i class="fa fa-arrow-left"></i></span>-->
          </div>
          <div class="reset-form">
            <div *ngIf="hasUser === false" class="not-found-account">
              <span><i class="fa fa-xmark"></i>Account not found</span>
            </div>
            <form [formGroup]="dataForm" (ngSubmit)="onSubmit()">
              <div class="form-input">
                <input type="text" placeholder="Enter phone number"
                       [class]="dataForm.get('username').touched && dataForm.get('username').invalid ? 'invalid' :''"
                       formControlName="username">
                <small *ngIf="dataForm.get('username').touched && dataForm.get('username').invalid">This
                  Field is
                  Required</small>
              </div>

              <div class="form-input" *ngIf="isOtpSent">
                <input type="text" placeholder="OTP Code"
                       [class]="dataForm.get('otp').touched && dataForm.get('otp').invalid ? 'invalid' :''"
                       formControlName="otp" [required]="isOtpSent">
                <small *ngIf="dataForm.get('otp').touched && dataForm.get('otp').invalid">This
                  Field is
                  Required</small>
              </div>
              <div class="form-input password" *ngIf="isOtpSent">
                <div class="password-area">
                  <p class="label">New password <sup>*</sup></p>
                  <input
                    [class]="dataForm.get('password').touched && dataForm.get('password').invalid ? 'invalid' :''"
                    [attr.type]="isPasswordShow ? 'text' : 'password'" placeholder="Enter new password"
                    formControlName="password">
                  <span (click)="onShowPassword()"><i
                    [class]="isPasswordShow ? 'fa fa-eye-slash' : 'fa fa-eye'"></i></span>
                </div>
                <small *ngIf="dataForm.get('password').touched && dataForm.get('password').invalid">This
                  Field is
                  Required</small>
              </div>

              <div class="form-sub">
                <button *ngIf="!isLoading" type="submit">Submit</button>
                <button *ngIf="isLoading" type="button">Please wait...</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>



